import { c as _c } from "react/compiler-runtime";
import { HotelCitiesMainContentPropertiesType } from "@website/accommodation-ui/hotel-cities-main-content/hotel-cities-main-content.types";
import uniqBy from "lodash-es/uniqBy";
import { useRouter } from "next/router";
import { useState } from "react";
export const useHotelCitiesMainContent = properties => {
  const $ = _c(29);
  const {
    hotelList,
    loading,
    hasError,
    hotelsSuggested,
    hasFilters,
    hasLoadMoreButton,
    clearAllFilters,
    setIsSearchPanelOpen
  } = properties;
  const router = useRouter();
  const [limit, setLimit] = useState(20);
  let handleNotFoundAction;
  let onLoadMore;
  let remainHotels;
  let t0;
  let t1;
  if ($[0] !== clearAllFilters || $[1] !== hasFilters || $[2] !== hasLoadMoreButton || $[3] !== hotelList || $[4] !== limit || $[5] !== setIsSearchPanelOpen) {
    const hotelListChunk = hotelList?.slice(0, limit);
    remainHotels = hotelList?.length - hotelListChunk?.length;
    let t2;
    if ($[11] !== clearAllFilters || $[12] !== hasFilters || $[13] !== setIsSearchPanelOpen) {
      t2 = () => {
        if (hasFilters) {
          clearAllFilters?.();
        } else {
          setIsSearchPanelOpen(true);
        }
      };
      $[11] = clearAllFilters;
      $[12] = hasFilters;
      $[13] = setIsSearchPanelOpen;
      $[14] = t2;
    } else {
      t2 = $[14];
    }
    handleNotFoundAction = t2;
    const suggestionOrder = Math.min(Math.max(hotelList?.length - 1, 1), 3);
    let t3;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = () => {
        setLimit(_temp);
      };
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    onLoadMore = t3;
    t0 = suggestionOrder;
    t1 = hasLoadMoreButton ? uniqBy(hotelListChunk, "id") : uniqBy(hotelList, "id");
    $[0] = clearAllFilters;
    $[1] = hasFilters;
    $[2] = hasLoadMoreButton;
    $[3] = hotelList;
    $[4] = limit;
    $[5] = setIsSearchPanelOpen;
    $[6] = handleNotFoundAction;
    $[7] = onLoadMore;
    $[8] = remainHotels;
    $[9] = t0;
    $[10] = t1;
  } else {
    handleNotFoundAction = $[6];
    onLoadMore = $[7];
    remainHotels = $[8];
    t0 = $[9];
    t1 = $[10];
  }
  const t2 = !loading && hotelList?.length === 0;
  const t3 = router.query?.order_by && router.query?.order_by !== "selling";
  const t4 = hotelsSuggested?.length !== 0;
  let t5;
  if ($[16] !== handleNotFoundAction || $[17] !== hasError || $[18] !== hasFilters || $[19] !== hasLoadMoreButton || $[20] !== loading || $[21] !== onLoadMore || $[22] !== remainHotels || $[23] !== t0 || $[24] !== t1 || $[25] !== t2 || $[26] !== t3 || $[27] !== t4) {
    t5 = {
      suggestionOrder: t0,
      hotelList: t1,
      loading,
      hasNoResults: t2,
      hasError,
      hasSort: t3,
      hasFilters,
      hasHotelSuggestion: t4,
      handleNotFoundAction,
      hasLoadMoreButton,
      remainHotels,
      onLoadMore
    };
    $[16] = handleNotFoundAction;
    $[17] = hasError;
    $[18] = hasFilters;
    $[19] = hasLoadMoreButton;
    $[20] = loading;
    $[21] = onLoadMore;
    $[22] = remainHotels;
    $[23] = t0;
    $[24] = t1;
    $[25] = t2;
    $[26] = t3;
    $[27] = t4;
    $[28] = t5;
  } else {
    t5 = $[28];
  }
  return t5;
};
function _temp(previousState) {
  return previousState + 20;
}